import { validarPermissao } from '@/commons/utils';

// O apelido é interno: fica oculto para quem não tem read:projeto (ex.: coordenador).
export const podeVerApelidoConta = () => validarPermissao('read:projeto');

export const camposBuscaConta = () => [
    'banco_nome',
    'agencia',
    'conta',
    ...(podeVerApelidoConta() ? ['apelido'] : []),
];

export const rotuloContaBancaria = (conta) => {
    if (!conta) return '';
    const agencia = conta.agencia_dv ? `${conta.agencia}-${conta.agencia_dv}` : conta.agencia;
    const operacao = conta.operacao ? ` • Operação ${conta.operacao}` : '';
    return `Agência ${agencia}, Conta ${conta.conta}-${conta.conta_dv}${operacao}`;
};

const luminancia = (canais) => {
    const [r, g, b] = canais.map((canal) => {
        const valor = canal / 255;
        return valor <= 0.03928 ? valor / 12.92 : ((valor + 0.055) / 1.055) ** 2.4;
    });

    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

const contraste = (a, b) => {
    const [maior, menor] = [luminancia(a), luminancia(b)].sort((x, y) => y - x);
    return (maior + 0.05) / (menor + 0.05);
};

// Mesmo padrão "soft" das outras tags, a partir da cor livre da conta: fundo claro e
// texto na própria cor, escurecido até ficar legível (ex.: amarelo).
export const estiloTagSuave = (cor) => {
    if (!/^#[0-9a-f]{6}$/i.test(cor ?? '')) return null;

    const canais = [1, 3, 5].map((inicio) => parseInt(cor.slice(inicio, inicio + 2), 16));
    const fundo = canais.map((canal) => Math.round(canal * 0.14 + 255 * 0.86));

    let texto = canais;
    while (contraste(texto, fundo) < 4.5) {
        texto = texto.map((canal) => Math.floor(canal * 0.9));
    }

    return { background: `rgb(${fundo.join(', ')})`, color: `rgb(${texto.join(', ')})` };
};

// Campo vazio vira null: é assim que a API remove o apelido ou a cor.
export const dadosApelidoConta = ({ apelido, cor }) => ({
    apelido: apelido?.trim() || null,
    cor: cor || null,
});
